var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { RequestClient } from "../basics/request-client.service";
import { autoinject } from "aurelia-framework";
import { Urls } from "../../constants/status-reason/status-reason.constants";
import { toNative } from "../../utilities/promise-utils";
var StatusReasonClientService = /** @class */ (function () {
    function StatusReasonClientService(requestClient) {
        this.requestClient = requestClient;
    }
    StatusReasonClientService.prototype.getStatusReasonTransitions = function () {
        return toNative(this.requestClient.get(Urls.GetStatusReasonTransitions, {}));
    };
    StatusReasonClientService.prototype.getAvailableStatusReasonTransitions = function (currentStatusReasonId, entityTypeId) {
        return toNative(this.requestClient.get(Urls.GetAvailableStatusReasonTransitions, { currentStatusReasonId: currentStatusReasonId, entityTypeId: entityTypeId }));
    };
    StatusReasonClientService.prototype.save = function (changes) {
        return this.requestClient.post(Urls.SaveStatusReasonTransitions, {}, { changes: changes });
    };
    StatusReasonClientService = __decorate([
        autoinject(),
        __metadata("design:paramtypes", [RequestClient])
    ], StatusReasonClientService);
    return StatusReasonClientService;
}());
export { StatusReasonClientService };
